// extracted by mini-css-extract-plugin
export var button = "_bj-7";
export var buttonRow = "_bj-6";
export var fadeIn = "_bj-1";
export var gradient = "_bj-0";
export var panel = "_bj-2";
export var panelIn = "_bj-3";
export var subtitle = "_bj-5";
export var title = "_bj-4";